/**
* @ngdoc directive
* @name Period Selector
*
* @description
  Period selector
*
* @scope
* @param {Array<{ end: '2017-01-01' }>} periods - periods to show in dropdown
* @param {String} emptyOptionName - shows name when no option selected
* @param {Function} onChange - callback fired when option changed
* @param {Number} selected - selected option number
*
* @example
  <period-selector
    periods="[{ name: '2017-01-01' }]"
    empty-option-name="Select Week"
    on-change="function(val) { console.log(val); }"
  ></period-selector>
*/

(function () {
  app.directive('periodSelector', ["PATH", "urlRedirectHandlerService", "userDataGAService", function(PATH, urlRedirectHandlerService, userDataGAService) {
    return {
      restrict: 'E',
      scope: {
        periods: '=',
        emptyOptionName: '@',
        onChange: '=',
        selected: '=?'
      },
      templateUrl: PATH.components + 'periodSelector/template.html',
      link: function ($scope) {
        var currentPeriod =
          getCurrentPeriod($scope.options) !== -1 ? getCurrentPeriod($scope.options) : 0;
        $scope.selected = currentPeriod && { id: currentPeriod } || $scope.selected;
        $scope.onPeriodChange = onPeriodChange;
        $scope.options = formatPeriods($scope.periods);
        if ($scope.selected) {
          onPeriodChange($scope.selected.id);
        }

        function onPeriodChange(optionIndex) {
          var option = $scope.options[optionIndex];
          if (option) {
            userDataGAService.sendGAEvent({
              eventCategory: 'Select by week',
              eventAction: 'selectByWeek',
              eventValue: option.start + ' - ' + option.end,
              additional: true
            });
          }

          $scope.onChange(optionIndex);
        }

        function getCurrentPeriod(periods) {
          var dateInUrl = urlRedirectHandlerService.getEndDateFormat();
          return dateInUrl && _.findIndex(periods, function(item) {
            return item.end === dateInUrl;
          });
        }

        function formatPeriods() {
          var format = 'MM/DD/YY';
          return _.map($scope.periods, function (period, index) {
            return {
              id: index,
              name: moment(period.start).format(format) + ' - '
                + moment(period.end).format(format)
            };
          });
        }
      }
    };
  }]);
})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/periodSelector/directive.js